<template>
    <div style="padding-left: 15px">
        <a-checkbox :indeterminate="indeterminate" @change="onCheckAllChange"
                    :checked="checkAll">
            {{$t('global.all')}}
        </a-checkbox>
        <a-checkbox-group :options="plainOptions" v-model="tableColumnsChecked" @change="onChange"/>
    </div>
</template>

<script>
    export default {
        name: "ZColumnCheck",
        props: ["columnOption"],
        data: function (){
            return {
                checkAll: false,
                indeterminate: true,
                plainOptions: [],
                tableColumnsChecked: []
            }
        },
        methods: {
            onChange(checkedList) {
                this.indeterminate = !!checkedList.length && (checkedList.length < this.plainOptions.length)
                this.checkAll = checkedList.length === this.plainOptions.length
                this.changeColumns()
            },
            onCheckAllChange(e) {
                this.indeterminate = false
                this.checkAll = e.target.checked
                this.tableColumnsChecked = []
                if(e.target.checked){
                    this.plainOptions.map(item =>{
                        this.tableColumnsChecked.push(item.value)
                    })
                }
                this.changeColumns()
            },
            changeColumns() {
                let leftColumns = []
                let rightColumns = []
                let columns = []
                let _this = this
                this.columnOption.columns.map(function(item){
                    let obj = _this.clone(item)
                    obj.title = item.unConvert ? obj.title : _this.$t('columnCheck.' + obj.title)
                    if(item.left == true) {
                        leftColumns.push(obj)
                    }else if(item.right == true){
                        rightColumns.push(obj)
                    } else if(_this.tableColumnsChecked.indexOf(item.title) != -1){
                        columns.push(obj)
                    }
                })
                this.columnOption.listColumns = [].concat(leftColumns).concat(columns).concat(rightColumns)
            },
            refresh(){
                let _this = this
                _this.plainOptions = []
                this.columnOption.columns.map(function(item){
                    if(!item.left && !item.right){
                        _this.plainOptions.push({"label":item.unConvert ? item.title : _this.$t('columnCheck.' + item.title),value:item.title})
                    }
                })
                this.changeColumns()
            },
            init() {
                let _this = this
                _this.plainOptions = []
                _this.tableColumnsChecked = []
                this.columnOption.columns.map(function(item){
                    if(!item.left && !item.right){
                        _this.plainOptions.push({"label":item.unConvert ? item.title : _this.$t('columnCheck.' + item.title),value:item.title})
                        if(item.checkColumn) {
                            _this.tableColumnsChecked.push(item.title)
                        }
                    }
                })
                if(_this.plainOptions.length === _this.tableColumnsChecked.length){
                    _this.checkAll = true
                    _this.indeterminate = false
                }
                this.changeColumns()
            },
            clone(obj){
                if (null == obj || "object" != typeof obj) return obj;
                if (obj instanceof Date) {
                    let copy = new Date();
                    copy.setTime(obj.getTime());
                    return copy;
                }
                if (obj instanceof Array) {
                    let copy = [];
                    var len = obj.length;
                    for (var i = 0; i < len; ++i) {
                        copy[i] = this.clone(obj[i]);
                    }
                    return copy;
                }
                if (obj instanceof Object) {
                    let copy = {};
                    for (var attr in obj) {
                        if (obj.hasOwnProperty(attr)) copy[attr] = this.clone(obj[attr]);
                    }
                    return copy;
                }
                throw new Error("Unable to copy obj! Its type isn't supported.");
            }
        },
        created() {
            this.init()
        }
    }
</script>
<style lang="less" scoped>
// .section-list {
//     padding: 20px !important;
// }
</style>
